import { createNamespacedHelpers } from 'vuex';

import api from './modules/api';
import signup from './modules/signup';

import apiActions from './actions/api';
import signupActions from './actions/signup';

export const { mapState, mapActions, mapMutations } = createNamespacedHelpers('legacy');

export default {
  namespaced: true,
  modules: {
    api,
    signup,
  },
  actions: {
    ...apiActions,
    ...signupActions,
  },
};
